import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Building, Users, ClipboardList, Upload, Activity, LogOut, Tag, ChevronDown, Search, DollarSign } from 'lucide-react';
import LogoutButton from './LogoutButton';
import './Sidebar.css';

const items = [
  { to: '/dashboard', label: 'Dashboard', Icon: Home },
  { to: '/imoveis', label: 'Imóveis', Icon: Building },
  { to: '/clientes', label: 'Clientes', Icon: Users },
  { to: '/vendas', label: 'Vendas', Icon: DollarSign },
  { to: '/checagens', label: 'Checagens', Icon: ClipboardList },
  {
    label: 'Processamentos',
    Icon: Activity,
    subItems: [
      { to: '/processamentos', label: 'Ver Processamentos', Icon: Activity },
      { to: '/importar_imoveis', label: 'Importar Imóveis', Icon: Upload },
      { to: '/buscar_proprietarios', label: 'Buscar Proprietários', Icon: Search },
    ],
  },
  { to: '/campanhas', label: 'Campanhas', Icon: ClipboardList },
  { to: '/eventos-cliente', label: 'Eventos Cliente', Icon: Activity },
  { to: '/etiquetas', label: 'Etiquetas', Icon: Tag },
];

const SubMenu = ({ item, collapsed }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  const isActive = item.subItems.some(subItem => pathname.startsWith(subItem.to));

  useEffect(() => {
    if (isActive) {
      setIsOpen(true);
    }
  }, [isActive]);

  const toggleSubMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`sidebar__submenu ${isOpen ? 'open' : ''}`}>
      <div
        className={`sidebar__link ${isActive ? 'active' : ''}`}
        onClick={toggleSubMenu}
        style={{ cursor: 'pointer' }}
      >
        <item.Icon size={20} />
        {!collapsed && <span className="sidebar__label">{item.label}</span>}
        {!collapsed && <ChevronDown size={16} className="sidebar__submenu-arrow" />}
      </div>
      {!collapsed && (
        <div className="sidebar__submenu-items">
          {item.subItems.map((subItem) => (
            <Link
              key={subItem.to}
              to={subItem.to}
              className={`sidebar__link sidebar__submenu-item ${pathname.startsWith(subItem.to) ? 'active' : ''}`}
            >
              <subItem.Icon size={20} />
              <span className="sidebar__label">{subItem.label}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};


const Sidebar = ({ onCollapseChange }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const width = collapsed ? 72 : 240;
    onCollapseChange?.(width);
    document.documentElement.style.setProperty('--sidebar-width', `${width}px`);
  }, [collapsed, onCollapseChange]);

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar__top">
        <div className="sidebar__brand">
          {!collapsed && <h2>vBroker</h2>}
        </div>
        <button
          aria-label="Toggle sidebar"
          className="sidebar__toggle"
          onClick={() => setCollapsed(c => !c)}
        >
          {collapsed ? '»' : '«'}
        </button>
      </div>

      <nav className="sidebar__nav">
        {items.map((item) =>
          item.subItems ? (
            <SubMenu key={item.label} item={item} collapsed={collapsed} />
          ) : (
            <Link
              key={item.to}
              to={item.to}
              className={`sidebar__link ${pathname.startsWith(item.to) ? 'active' : ''}`}
              title={collapsed ? item.label : undefined}
            >
              <item.Icon size={20} />
              {!collapsed && <span className="sidebar__label">{item.label}</span>}
            </Link>
          )
        )}
        <div className="sidebar__logout-mobile">
          <LogoutButton icon={LogOut} collapsed />
        </div>
      </nav>

      <div className="sidebar__footer">
        <LogoutButton collapsed={collapsed} />
      </div>
    </aside>
  );
};

export default Sidebar;

